@if (loading) {
<div class="gt-filter-container">
  <div class="col">
    <i class="fa fa-spinner fa-spin gt-refresh"></i>
  </div>
</div>
}

@if (showFilters && !loading) {
<div class="gt-filter-container">
  <div class="col">
    <i class="fa fa-refresh gt-refresh" (click)="refresh()" title="Refresh Data"></i>
  </div>

  @if (hasFilterModel) {

    @for (filter of primaryFilters; track $index) {
<div class="col filter-chip">
      <span class="chip-key">{{ filter.display_name || filter.param_name || filter.filter_key }}</span>
      <span class="chip-sep">:</span>
      @if (isSingleSelectFilter(filter)) {

        <select
          class="filter-select"
          [ngModel]="getSingleSelectedValue(filter)"
          (ngModelChange)="onSingleFilterChange(filter, $event)"
        >
          <option value="">Select</option>
          @for (option of getFilterOptions(filter); track $index) {
<option [value]="getOptionValue(option)">
            {{ getOptionLabel(option) }}
          </option>
}
        </select>
      
} @else {

        @if (isMeDropFilter(filter)) {

          <details class="me-filter-details">
            <summary class="me-filter-summary">{{ getMeSelectedKeys(filter).length }} selected</summary>
            <div class="me-filter-list">
              <div class="me-filter-actions">
                <span class="me-filter-link" (click)="onMeFilterSelectAll(filter)">Select All</span>
                <span class="me-filter-link" (click)="onMeFilterUnselectAll(filter)">Unselect All</span>
              </div>
              @for (option of getMeDropOptions(filter); track $index) {
<label class="me-filter-option">
                <input
                  type="checkbox"
                  [checked]="isMeOptionSelected(filter, option.key)"
                  (change)="onMeFilterSelectionChange(filter, option.key, $any($event.target).checked)"
                />
                <span [ngClass]="option.level" [style.margin-left.px]="meOptionIndent(option)">{{ option.name }}</span>
              </label>
}
            </div>
          </details>
        
} @else {

          <span class="chip-value">{{ getSelectedLabel(filter) }}</span>
        
}
        
      
}
      
    </div>
}

    @for (filter of toggleFilters; track $index) {
<div class="col filter-chip toggle-chip">
      <span class="chip-key">{{ filter.display_name || filter.param_name || filter.filter_key }}</span>
      <span class="chip-sep">:</span>
      @if (isSingleSelectFilter(filter)) {

        <select
          class="filter-select"
          [ngModel]="getSingleSelectedValue(filter)"
          (ngModelChange)="onSingleFilterChange(filter, $event)"
        >
          <option value="">Select</option>
          @for (option of getFilterOptions(filter); track $index) {
<option [value]="getOptionValue(option)">
            {{ getOptionLabel(option) }}
          </option>
}
        </select>
      
} @else {

        @if (isMeDropFilter(filter)) {

          <details class="me-filter-details">
            <summary class="me-filter-summary">{{ getMeSelectedKeys(filter).length }} selected</summary>
            <div class="me-filter-list">
              <div class="me-filter-actions">
                <span class="me-filter-link" (click)="onMeFilterSelectAll(filter)">Select All</span>
                <span class="me-filter-link" (click)="onMeFilterUnselectAll(filter)">Unselect All</span>
              </div>
              @for (option of getMeDropOptions(filter); track $index) {
<label class="me-filter-option">
                <input
                  type="checkbox"
                  [checked]="isMeOptionSelected(filter, option.key)"
                  (change)="onMeFilterSelectionChange(filter, option.key, $any($event.target).checked)"
                />
                <span [ngClass]="option.level" [style.margin-left.px]="meOptionIndent(option)">{{ option.name }}</span>
              </label>
}
            </div>
          </details>
        
} @else {

          <span class="chip-value">{{ getSelectedLabel(filter) }}</span>
        
}
        
      
}
      
    </div>
}
  
} @else {

    @for (filter of filterEntries; track $index) {
<div class="col filter-chip">
      <span class="chip-key">{{ filter.key }}</span>
      <span class="chip-sep">:</span>
      <span class="chip-value">{{ filter.value }}</span>
    </div>
}
  
}

  

  <div class="col">
    @if (hasFilterModel || filterEntries.length) {
<div class="btn btn-xs btn-success" (click)="refresh()">Filter</div>
}
    @if (hasFilterModel || filterEntries.length) {
<div
      class="btn btn-xs btn-success"
     
      (click)="downloadSelectedFiltersData()"
      id="filtered-data-download-btn"
    >
      Download
    </div>
}
    @if (screenKey === 11442) {
<div class="btn btn-xs btn-success" (click)="launchCustomModalForSpecificScreen(11442)">Add New Service</div>
}
    @if (screenKey === 10898) {
<div class="btn btn-xs btn-success" (click)="launchCustomModalForSpecificScreen(10898)">Create New Group</div>
}
    @if (screenKey === 10895) {
<div class="btn btn-xs btn-success" (click)="launchCustomModalForSpecificScreen(10895)">Create State Entity</div>
}
    @if (screenKey === 11149) {
<div class="btn btn-xs btn-success" (click)="launchCustomModalForSpecificScreen(11149)">Create New Override Entity</div>
}
    @if (screenKey === 11163) {
<div class="btn btn-xs btn-success" (click)="launchCustomModalForSpecificScreen(11163)">Create Scenario Entity</div>
}
    @if (screenKey === 11165) {
<div class="btn btn-xs btn-success" (click)="launchCustomModalForSpecificScreen(11165)">Create Reference Table Entity</div>
}
    @if (screenKey === 11166) {
<div class="btn btn-xs btn-success" (click)="launchCustomModalForSpecificScreen(11166)">Create Configuration Entity</div>
}
    @if (screenKey === 11167) {
<div class="btn btn-xs btn-success" (click)="launchCustomModalForSpecificScreen(11167)">Create Filing Date Entity</div>
}
    @if (screenKey === 11446) {
<div class="btn btn-xs btn-success" (click)="launchCustomModalForSpecificScreen(11446)">Create Refresh Setup Entity</div>
}
    @if (screenKey === 11451) {
<div class="btn btn-xs btn-success" (click)="launchCustomModalForSpecificScreen(11451)">Create Quarter Map Entity</div>
}
    @if (screenKey === 11462) {
<div class="btn btn-xs btn-success" (click)="launchCustomModalForSpecificScreen(11462)">Add New</div>
}
    @if (screenKey === 11463) {
<div class="btn btn-xs btn-success" (click)="launchCustomModalForSpecificScreen(11463)">Add New</div>
}
    @if (screenKey === 11464) {
<div class="btn btn-xs btn-success" (click)="launchCustomModalForSpecificScreen(11464)">Add New</div>
}
    @if (screenKey === 11465) {
<div class="btn btn-xs btn-success" (click)="launchCustomModalForSpecificScreen(11465)">Add New</div>
}
    @if (screenKey === 11466) {
<div class="btn btn-xs btn-success" (click)="launchCustomModalForSpecificScreen(11466)">Add New</div>
}
    @if (screenKey === 11467) {
<div class="btn btn-xs btn-success" (click)="launchCustomModalForSpecificScreen(11467)">Add New</div>
}
    @if (screenKey === 11476) {
<div class="btn btn-xs btn-success" (click)="launchCustomModalForSpecificScreen(11476)">Add New</div>
}
    @if (screenKey === 11477) {
<div class="btn btn-xs btn-success" (click)="launchCustomModalForSpecificScreen(11477)">Add New</div>
}
    @if (screenKey === 11673) {
<div class="btn btn-xs btn-success" (click)="launchCustomModalForSpecificScreen(11673)">Add New</div>
}
    @if (screenKey === 11468) {
<div class="btn btn-xs btn-success" (click)="launchCustomModalForSpecificScreen(11468)">Create Threshold Management</div>
}
    @if (screenKey === 11555) {
<div class="btn btn-xs btn-success" (click)="launchCustomModalForSpecificScreen(11555)">Create 851 Config Entity</div>
}
    @if (screenKey === 11554) {
<div class="btn btn-xs btn-success" (click)="launchCustomModalForSpecificScreen(11554)">Create LE Override</div>
}
    @if (screenKey === 11616) {
<div class="btn btn-xs btn-success" (click)="launchCustomModalForSpecificScreen(11616)">Create Default Sourcing Override</div>
}
    @if (screenKey === 11618) {
<div class="btn btn-xs btn-success" (click)="launchCustomModalForSpecificScreen(11618)">Extract Elements from XML</div>
}
  </div>

  <div class="col">
    @if (!filterMatch) {
<div>
      <i class="fa fa-exclamation-triangle" title="Warning! Filters do not match with the current cached data"></i>
    </div>
}
  </div>

  <div class="col docs-btn-wrap">
    <div class="btn btn-xs" (click)="openDocument()">
      <i class="fa fa-file docs-icon"></i>
    </div>
  </div>
</div>
}
